import { Component, OnInit,ViewChild } from '@angular/core';
import { NgForm } from "@angular/forms";
import { DateAdapter } from '@angular/material';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from "@angular/common";
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { CenterService } from "./shared/center.service";

@Component({
  selector: 'app-center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.css']
})
export class CenterComponent implements OnInit {

  AddButtonText: string = "Add";
  ErrorText: string;
  dataSourceList = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  ParentCenterNo: number=0;
  BranchList: any[] = [];
  CollectionTypeList:[''];
  public divBankDetails:boolean = false;

  constructor(private router: Router,private activatedRoute:ActivatedRoute,
    public centerService: CenterService) { }

  ngOnInit() {
    this.activatedRoute.params.subscribe(param => {
      this.ParentCenterNo = + param['Id'];  //Parent ChequeNo
    });
  
   
    
    this.GetCollectionTypeList(); 
    this.GetBranchList();
    // this.GetChequeByChequeNo();
    this.resetForm();
    if (Number.isNaN(this.ParentCenterNo)) {
      this.centerService.selectedCenter.Id = 0;
      this.centerService.selectedCenter.Flag = 1;
      this.centerService.selectedCenter.IsActive = 1;
      this.AddButtonText = "Save";
    }
    else {
      this.centerService.selectedCenter.Id = +this.ParentCenterNo;
      this.centerService.selectedCenter.Flag = 2;
      this.AddButtonText = "Edit & Save";
      this.GetCenterByCenterNo();
    }  

    this.dataSourceList.paginator = this.paginator;
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();

    this.centerService.selectedCenter = {
      Id : 0,
      CentreName : null,
      CentreCode : null,
      BranchId : 0,
      LeaderName : null,
      AsstLeaderName : null,
      ContactName : null,
      BranchManagerName : null,
      CreditExecutiveName : null,
      ContactNo : null,
      MaxMembers : null,
      MaxGroups : null,
      Distancefrombranch : null,
      LocationName : null,
      LocationLandMark : null,
      MeetingDay :  '0',
      CollectionTypeId : 0,
      CollectionPlace : null,
      CollectionTime :'12:00 PM',
      BankDetails : null,
      EmployeeId : null,
      EmployeeBranchId : null,
      CompanyId : null,
      SaasId : null,
      CreatedDate: null,
      ModifiedDate: null,
      IsActive: 0,
      Flag: 0,
    }
  }

  public onSubmit(form: NgForm) {
    form.value.CompanyId   = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    form.value.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    form.value.EmployeeId   = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    form.value.SaasId       = JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    form.value.CreatedDate  =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];
    form.value.ModifiedDate =  JSON.parse(localStorage.getItem("EmployeeData"))["ApplicationDate"];

    this.centerService.IUDCenter(form.value)
      .subscribe(data => {
 
        if (data[0].ResponseId != 500) {
          this.ErrorText = data[0].ResponseMessage;
          this.resetForm(form);
          this.router.navigate(['/centerlist']);
        }
        else {
          this.ErrorText = data[0].ResponseMessage;
        }
      })
  }

  GetCenterByCenterNo() {

    if (!Number.isNaN(this.ParentCenterNo)) {
      this.centerService.selectedCenter.Id = this.ParentCenterNo;
      this.centerService.FetchCenterByCenterId(this.centerService.selectedCenter).subscribe(data => {

        this.centerService.selectedCenter = data;
        this.centerService.selectedCenter.Id = +data.Id;
        // this.centerService.selectedCenter.MeetingDay = data.MeetingDay;
        this.centerService.selectedCenter.Flag = 2;
        if(data.CollectionTypeId){
        this.divBankDetails = true;
        }
        else{
          this.divBankDetails =false;
        }
      })
    }
  }
   
  GetBranchList() {
    this.centerService.GetBranchList().subscribe(data => {
      this.BranchList = data;
    })
  }

  GetCollectionTypeList(){
    this.centerService.GetCollectionTypeList().subscribe(data => {
      this.CollectionTypeList = data;
    })
  }

  selectCollectionTypeChange(id: any){

   if(id==2){
   this.divBankDetails =false;
   }
   else{
    this.divBankDetails =true;
   }

  }


}
